import React, { useState } from 'react';
import { t as uiText } from '../../../i18n';
import { useEmailVerification } from '../EmailVerificationContext';

export function resendErrorMessage(code: string): string {
  if (code === 'COOLDOWN' || code === 'RATE_LIMITED') {
    return uiText('Please wait a moment before trying again.');
  }
  if (code === 'unauthenticated') return uiText('Please sign in again.');
  return uiText('Could not send the confirmation email. Please try again later.');
}

interface Props {
  className?: string;
}

/** 確認メール再送ボタン（二重送信防止・クールダウン・結果メッセージ付き） */
const ResendButton: React.FC<Props> = ({ className }) => {
  const { resend, cooldownSec } = useEmailVerification();
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState<{ kind: 'ok' | 'error'; text: string } | null>(null);

  const onClick = async () => {
    if (busy || cooldownSec > 0) return;
    setBusy(true);
    setMessage(null);
    const r = await resend();
    setBusy(false);
    setMessage(
      'code' in r
        ? { kind: 'error', text: resendErrorMessage(r.code) }
        : { kind: 'ok', text: uiText('Confirmation email sent. Please check your inbox.') }
    );
  };

  return (
    <>
      <button
        type="button"
        className={`ev-btn ${className ?? ''}`}
        onClick={onClick}
        disabled={busy || cooldownSec > 0}
      >
        {cooldownSec > 0
          ? uiText('Resend confirmation email ({{sec}}s)', { sec: cooldownSec })
          : uiText('Resend confirmation email')}
      </button>
      {message && (
        <div
          className={message.kind === 'ok' ? 'ev-msg ev-msg-ok' : 'ev-msg ev-msg-error'}
          role={message.kind === 'ok' ? 'status' : 'alert'}
        >
          {message.text}
        </div>
      )}
    </>
  );
};

export default ResendButton;
